import { onFormError } from '../../../core/utils/hooks'
import { notification } from 'antd'

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  loadSmtp,
  updateSmtp
} from '../../../api/admin/setting'

const key = 'admin.settings.smtp'

export const useFetch = () => {
  return useQuery({
    queryKey: [key],
    queryFn: () => loadSmtp()
  })
}

export const useUpdateSmtp = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateSmtp,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The SMTP configuration was updated.'
      })
    },
    onError: onFormError
  })
}
